<template>
    <div id="subContents" class="intro wrap_1120">
        <section id="introCon" class="intro-page">
            <article class="intro-con">
                <h3 class="intro-tit font-lottemart">
                    여성과 함께, 시민과 함께,
                    <span>다시함께</span>
                </h3>
                <div class="intro-img-box">
                    <ul class="intro-img-list">
                        <li>
                            <span class="tit font-lottemart">비전</span>
                            <img src="@/assets/intro_cir_img_01.png" alt="" />
                            <p class="txt">
                                성착취 없는
                                <br />
                                여성 존엄이 실현된 성평등 사회
                            </p>
                        </li>
                        <li>
                            <span class="tit font-lottemart">미션</span>
                            <img src="@/assets/intro_cir_img_02.png" alt="" />
                            <p class="txt">
                                여성과 함께 성착취 구조에 저항하고,
                                <br />
                                시민과 함께 사회적 편견에 도전하기
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="txt-con">
                    <p class="txt">
                        <b class="font-lottemart">서울특별시립 다시함께상담센터는</b>
                        <strong>한국YMCA전국연맹</strong>
                        이 서울시로부터 수탁하여 성매매피해자의 인권을 보호하고,
                        <br class="no_640" />
                        성매매를 예방·축소·감시하기 위한 다양한 활동을 하고 있습니다.
                    </p>
                </div>
                <div class="logo-con">
                    <ul class="logo-list">
                        <li class="icon_wrap"><img src="@/assets/intro_logo_01.jpg" alt="" /></li>
                        <li class="icon_wrap"><img src="@/assets//intro_logo_02.jpg" alt="" /></li>
                    </ul>
                </div>
            </article>
        </section>
    </div>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        userStore,
        PageBtn,
        ModalDefault,
        onBeforeMount,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,
            });

            onBeforeMount(() => {});

            onMounted(() => {});

            return { state, router, CommonUtils };
        },
    };
</script>
<style scoped>
    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
    .elips_1 .block {
        width: 100%;
        display: inline-block;
    }
</style>

<style scoped>
    /* ****************** 소개 ****************** */
    /* ---------- 다시함께는? ---------- */
    .intro-page {
        /* margin-top: 27px;  */
    }
    /* 다시함께는? */
</style>
